'use strict';

const ModalView = require('../../js/components/ModalView');
const YouTubePlayer = require('../../js/components/YouTubePlayer');
const BrightcoveVideoPlayer = require('../BrightcoveVideoPlayer/BrightcoveVideoPlayer');
const templateImage = require('./PDPImageModal-image.hbs');
const templateYoutube = require('./PDPImageModal-youtube.hbs');
const templateBrightcove = require('./PDPImageModal-brightcove.hbs');

const PDPImageModal = ModalView.extend({
  initialize: function() {
    PDPImageModal.__super__.initialize.apply(this, arguments);

    this.on('modal:open', this.open);
  },

  open: function(data) {
    // Use the right template
    if (data.youTubeVideoId) {
      this.template = templateYoutube;
    } else if (data.brightcoveVideoId && data.brightcovePlayer && data.brightcoveAccount) {
      this.template = templateBrightcove;
    } else {
      this.template = templateImage;
    }

    PDPImageModal.__super__.open.call(this, data);
  },

  onOpen: function() {
    YouTubePlayer.create(this.$el);
    BrightcoveVideoPlayer.create(this.$el);
  },

  onClose: function() {
    // Clear modal contents - stops videos playing
    this.$el.html('');
  }
});

export default PDPImageModal;



// WEBPACK FOOTER //
// ./assets/components/PDPImageCarousel/PDPImageModal.js